import { useMemo } from 'react';
import { UserSortingField } from '../../../api/types';
import makeGetSortingRule from '../../../utilities/makeGetSortingRule';

export const getSortField = makeGetSortingRule((field): UserSortingField => {
    switch (field) {
        case 'module.company.displayName':
            return UserSortingField.Company;

        case 'email':
            return UserSortingField.Email;

        case 'displayName':
            return UserSortingField.DisplayName;

        case 'mobile.value':
            return UserSortingField.Mobile;

        case 'roles':
            return UserSortingField.Role;

        case 'lastSignedIn':
            return UserSortingField.LastSignedIn;

        case 'isAuthenticatorEnabled':
            return UserSortingField.Authenticator;

        case 'userGroups':
            return UserSortingField.UserGroup;

        default:
            throw new Error('Unknown Sorting Field!');
    }
});

const useSortOrder = sort => {
    const emailSort = useMemo(() => (sort.field === UserSortingField.Email ? sort.orderValue : undefined), [sort]);

    const nameSort = useMemo(() => (sort.field === UserSortingField.DisplayName ? sort.orderValue : undefined), [sort]);

    const mobileSort = useMemo(() => (sort.field === UserSortingField.Mobile ? sort.orderValue : undefined), [sort]);

    const lastSignSort = useMemo(
        () => (sort.field === UserSortingField.LastSignedIn ? sort.orderValue : undefined),
        [sort]
    );

    return {
        emailSort,
        nameSort,
        mobileSort,
        lastSignSort,
    };
};

export default useSortOrder;
